import type { SupplierProductGetResponseChildType } from "@sellar-io/api-v2/types";
import { forwardRef } from "react";
import { BasicProductItemAvailabilitySection } from "./BasicProductItemAvailabilitySection";
import { AdvancedProductItemAvailabilitySection } from "./AdvancedProductItemAvailabilitySection";

export type ProductItemAvailabilitySectionHandle = {
  save: () => Promise<void>;
};

export const ProductItemAvailabilitySection = forwardRef<
  ProductItemAvailabilitySectionHandle,
  { product: SupplierProductGetResponseChildType; mode: "basic" | "advanced" }
>(({ product, mode }, ref) => {
  return mode === "basic" ? (
    <BasicProductItemAvailabilitySection ref={ref} product={product} />
  ) : (
    <AdvancedProductItemAvailabilitySection ref={ref} product={product} />
  );
});

ProductItemAvailabilitySection.displayName = "ProductItemAvailabilitySection";
